import { render, staticRenderFns } from "./VillageMap.vue?vue&type=template&id=a26c868e&scoped=true"
import script from "./VillageMap.vue?vue&type=script&lang=js"
export * from "./VillageMap.vue?vue&type=script&lang=js"
import style0 from "./VillageMap.vue?vue&type=style&index=0&id=a26c868e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26c868e",
  null
  
)

export default component.exports